// Magic Arbuz Mobile - i18n dictionary, driven by the app's global LanguageContext.
import { useLang } from '../context/LanguageContext';

export const MA_T = {
  en: {
    tab_mint:'Mint', tab_cards:'Cards', tab_activity:'Activity', tab_inugami:'Inugami', tab_arbuzino:'Six',
    connect_tagline:'Smart contracts on Bitcoin', connect_wallet:'CONNECT WALLET',
    hdr_mintArbuz:'Mint', hdr_burnDraw:'Mint a card',
    hdr_deck:'Cards', hdr_floor:'Activity', hdr_inugami:'Inugami',
    seg_mintArbuz:'Mint Arbuz', seg_mintCard:'Mint card',
    eb_yourArbuz:'Your Arbuz balance', eb_routing:'Routing', eb_stake:'Fee rate · sat/vB',
    eb_batch:'Batch · transactions amount',
    cost_acai:'Fartanium contract fee', cost_net:'Network fee', cost_total:'Total cost',
    cards_generated:'Cards generated', cards_burned:'Arbuz burned', cards_owned:'Owned',
    cards_collection:'Collection',
    cards_gateTitle:'Cards live in your wallet',
    cards_gateBody:"Connect a Bitcoin wallet to reveal the cards you've minted.",
    cards_emptyTitle:'Your deck is empty', cards_emptySub:'Send 100 Arbuz during an open window to draw your first card.',
    hold_emptyTitle:'No Arbuz yet', hold_emptySub:'Mint one here.',
    act_minutesHour:'Mints / hour · last 24h', act_peak:'peak', act_none:'No mints to show.',
    f_all:'Recent', f_yours:'Yours', f_hideRip:'Hide ripening', f_showRip:'Show ripening',
    inu_locked:'Locked right now', inu_phrase:'The phrase', inu_copy:'Copy phrase', inu_copied:'Copied ✓', inu_how:'How it works', inu_loadFailed:"Couldn't load bounty", inu_retry:'Retry',
    learn:'Learn how it works', refresh:'refresh',
    btn_selectFee:'SELECT FEE', btn_tapMintArbuz:'TAP TO MINT', btn_insertArbuz:'INSERT AN ARBUZ', btn_tapMintCard:'TAP TO MINT CARD',
    btn_track:'TRACK ON ACTIVITY', btn_mintAgain:'Mint again', btn_close:'Close', btn_viewDeck:'VIEW ON DECK', btn_viewExplorer:'View on explorer ↗',
    cost_burning:'Burning', eb_holdings:'Holdings', cv_emptyTitle:'NEED 100 ARBUZ', cv_noEligible:'Hold at least 100 Arbuz in a single UTXO to draw a card.',
    wb_last:'Last block', wb_next:'Next window', wb_wait:'Time to wait', wb_now:'MINT NOW',
    step_insert:'Insert an Arbuz', step_sign:'Sign & send',
    rv_pulling:'Submitting', rv_pullingN:'Submitting', rv_ripening:'Ripening',
    rv_signBroadcast:'sign the transaction in your wallet', rv_signWallet:'Confirm in wallet…', rv_broadcast:'Broadcast to mempool',
    rv_creating:'Creating PSBT…', rv_broadcasting:'Broadcasting…',
    rv_burnDraw:'Burn Arbuz → draw a card', rv_signInscribe:'sign to burn 100 ARBUZ and draw your card', rv_cardSent:'Card mint sent',
    rv_cfNew:'NEW', rv_cfMinting:'Card minting',
    tx_single:'Transaction ID', tx_many:'Transactions', tx_copy:'COPY', tx_copied:'COPIED', tx_copyAll:'copy all', tx_inMempool:'In mempool', tx_explorer:'EXPLORER',
    toast_mintSent:'Mint transaction successfully sent',
    toast_partialBatch:(got,want)=>`Balance only covered ${got} of ${want} mints — ${got} sent`,
    btn_dismiss:'Dismiss', btn_retry:'TRY AGAIN',
    hold_loadFail:'Failed to load holdings — tap refresh to retry.',
    cards_loadFail:'Failed to load your deck — the indexer may be down. Your cards are safe on-chain.',
    btn_back:'BACK',
    cd_cardIndex:'Card index', cd_traits:'TRAITS', cd_mystical:'MYSTICAL SYMBOLS', cd_provenance:'PROVENANCE',
    cd_block:'BLOCK', cd_txIndex:'TX INDEX', cd_bg:'Background', cd_symbol:'Main symbol', cd_border:'Border', cd_glow:'Glow', cd_class:'Class', cd_numeral:'Numeral',
    cd_outpoint:'Outpoint', cd_alkane:'Alkane', cd_mintDate:'Mint date', cd_tapReveal:'TAP TO REVEAL',
    act_confirmedTitle:'Confirmed Arbuz mints', act_statsError:"Couldn't get node data, try again", kpi_of:'of', kpi_tokenMinted:'ARBUZ MINTED',
    kpi_last24:'Last 24h', kpi_lastBlock:'Last block', kpi_rate:'Mint rate', kpi_mintsSent:'mints sent', kpi_mintTxs:'mint transactions', kpi_perHr:'per hr',
    ax_24h:'24h ago', ax_now:'now',
    act_histMints:(n)=>`${n} mint txs`, act_histWhen:(ago)=>ago===0?'now':`${ago}h ago`,
    inu_phraseDesc:'A miner who writes this exact string into their coinbase scriptSig claims the entire pot.', inu_scriptsig:'SCRIPTSIG · UTF-8',
    inu_r1n:'BloodOath', inu_r1d:'Lock DIESEL against a phrase - anyone can deposit to the pot.',
    inu_r2n:'BindSigil', inu_r2d:'A miner whose coinbase carries the phrase sweeps the entire pot.',
    inu_r3n:'SigilTrove', inu_r3d:'Read-only - check the current bounty before depositing.',
    mc_selectWallet:'Connect', mc_openInApp:'Open this page inside the Xverse, Unisat or OKX app browser to connect.',
    mc_connectFloor:'Choose your', mc_connectHi:'wallet', mc_installed:'Installed', mc_openApp:'Open in app', mc_errRejected:'Request rejected in wallet', mc_connectFailed:'Connection failed, please try again',
    mc_termsPre:'By connecting you agree to the ', mc_termsLink:'terms',
    rt_public:'Public', rt_rebar:'Rebar', rt_publicSub:'open mempool', rt_rebarSub:'private pool',
    fee_slow:'Slow', fee_normal:'Normal', fee_fast:'Fast', fee_custom:'Custom',
  },
  zh: {
    tab_mint:'铸造', tab_cards:'卡牌', tab_activity:'动态', tab_inugami:'Inugami', tab_arbuzino:'Six',
    connect_tagline:'比特币上的智能合约', connect_wallet:'连接钱包',
    hdr_mintArbuz:'铸造', hdr_burnDraw:'铸造卡牌',
    hdr_deck:'卡牌', hdr_floor:'动态', hdr_inugami:'Inugami',
    seg_mintArbuz:'铸造 ARBUZ', seg_mintCard:'铸造卡牌',
    eb_yourArbuz:'你的 Arbuz 余额', eb_routing:'路由', eb_stake:'费率 sat/vB',
    eb_batch:'批量 · 交易数量',
    cost_acai:'Fartanium 合约费', cost_net:'网络费', cost_total:'总成本',
    cards_generated:'已生成卡牌', cards_burned:'已销毁 Arbuz', cards_owned:'拥有',
    cards_collection:'收藏',
    cards_gateTitle:'卡牌存于你的钱包',
    cards_gateBody:'连接比特币钱包，查看你铸造的卡牌。',
    cards_emptyTitle:'你的卡组是空的', cards_emptySub:'在开放窗口期间发送 100 Arbuz 抽取你的第一张卡牌。',
    hold_emptyTitle:'还没有 Arbuz', hold_emptySub:'在这里铸造一个。',
    act_minutesHour:'每小时铸造 · 近24小时', act_peak:'峰值', act_none:'暂无铸造记录。',
    f_all:'最近', f_yours:'我的', f_hideRip:'隐藏催熟中', f_showRip:'显示催熟中',
    inu_locked:'当前锁定', inu_phrase:'暗语', inu_copy:'复制暗语', inu_copied:'已复制 ✓', inu_how:'运作方式', inu_loadFailed:'赏金加载失败', inu_retry:'重试',
    learn:'了解运作方式', refresh:'刷新',
    btn_selectFee:'选择费率', btn_tapMintArbuz:'点击铸造', btn_insertArbuz:'放入 ARBUZ', btn_tapMintCard:'点击铸造卡牌',
    btn_track:'在动态中追踪', btn_mintAgain:'再次铸造', btn_close:'关闭', btn_viewDeck:'在卡组中查看', btn_viewExplorer:'在浏览器查看 ↗',
    cost_burning:'销毁', eb_holdings:'持仓', cv_emptyTitle:'需要 100 ARBUZ', cv_noEligible:'单个 UTXO 中需持有至少 100 Arbuz 才能抽卡。',
    wb_last:'上一区块', wb_next:'下一窗口', wb_wait:'等待时间', wb_now:'立即铸造',
    step_insert:'放入一个 Arbuz', step_sign:'签名并发送',
    rv_pulling:'提交中', rv_pullingN:'提交中', rv_ripening:'催熟中',
    rv_signBroadcast:'在钱包中签名以广播', rv_signWallet:'在钱包中签名…', rv_broadcast:'广播到内存池',
    rv_creating:'构建 PSBT…', rv_broadcasting:'广播中…',
    rv_burnDraw:'烧毁 ARBUZ → 抽取卡牌', rv_signInscribe:'签名以烧毁 100 ARBUZ 并抽取卡牌', rv_cardSent:'卡牌铸造已发送',
    rv_cfNew:'新', rv_cfMinting:'卡牌铸造中',
    tx_single:'交易 ID', tx_many:'交易', tx_copy:'复制', tx_copied:'已复制', tx_copyAll:'全部复制', tx_inMempool:'在内存池', tx_explorer:'浏览器',
    toast_mintSent:'铸造交易已成功发送',
    toast_partialBatch:(got,want)=>`余额仅够 ${want} 笔中的 ${got} 笔 — 已发送 ${got} 笔`,
    btn_dismiss:'关闭', btn_retry:'重试',
    hold_loadFail:'持仓加载失败 — 点击刷新重试。',
    cards_loadFail:'卡组加载失败 — 索引器可能暂时不可用。你的卡牌安全地保存在链上。',
    btn_back:'返回',
    cd_cardIndex:'卡片索引', cd_traits:'特征', cd_mystical:'神秘符号', cd_provenance:'来源',
    cd_block:'区块', cd_txIndex:'TX 索引', cd_bg:'背景', cd_symbol:'主符号', cd_border:'边框', cd_glow:'发光', cd_class:'类别', cd_numeral:'数字',
    cd_outpoint:'输出点', cd_alkane:'Alkane', cd_mintDate:'铸造日期', cd_tapReveal:'点击翻开',
    act_confirmedTitle:'已确认的 Arbuz 铸造', act_statsError:'无法获取节点数据，请重试', kpi_of:'共', kpi_tokenMinted:'ARBUZ 已铸造',
    kpi_last24:'近24小时', kpi_lastBlock:'上一区块', kpi_rate:'铸造速率', kpi_mintsSent:'笔已发送', kpi_mintTxs:'铸造交易', kpi_perHr:'每小时',
    ax_24h:'24小时前', ax_now:'现在',
    act_histMints:(n)=>`${n} 次`, act_histWhen:(ago)=>ago===0?'现在':`${ago}小时前`,
    inu_phraseDesc:'矿工将此字符串写入其 coinbase scriptSig 即可领取全部赏金。', inu_scriptsig:'脚本签名 · UTF-8',
    inu_r1n:'血誓', inu_r1d:'将 DIESEL 锁定至短语 - 任何人都可向赏金池存入。',
    inu_r2n:'绑定印记', inu_r2d:'coinbase 携带该短语的矿工取走全部赏金池。',
    inu_r3n:'印记宝库', inu_r3d:'只读 - 存入前查看当前赏金。',
    mc_selectWallet:'连接', mc_openInApp:'在 Xverse、Unisat 或 OKX 应用内浏览器中打开此页面以连接。',
    mc_connectFloor:'选择你的', mc_connectHi:'钱包', mc_installed:'已安装', mc_openApp:'在应用中打开', mc_errRejected:'请求在钱包中被拒绝', mc_connectFailed:'连接失败，请重试',
    mc_termsPre:'连接即表示你同意', mc_termsLink:'条款',
    rt_public:'公开', rt_rebar:'Rebar', rt_publicSub:'公开内存池', rt_rebarSub:'私有矿池',
    fee_slow:'慢', fee_normal:'普通', fee_fast:'快', fee_custom:'自定义',
  },
};

export function useMobT() {
  const { lang, setLang } = useLang();
  const t = (k) => { const d = MA_T[lang] || MA_T.en; return (k in d) ? d[k] : (MA_T.en[k] !== undefined ? MA_T.en[k] : k); };
  return { lang, setLang, t };
}
